import React from "react";
//#region types
import { SalarReportWarningsProps } from "models/propTypes/salaryPropTypes";
import { StyleEnums } from "models/enums";
import { SnackbarKey } from "notistack";
//#endregion
//#region components
import { useFloatingMessages } from "components/common";
import PersonSalaryWarningContent from "./salaryWarningContent";
//#endregion

const SalaryReportWarnings: React.FC<SalarReportWarningsProps> = (props) => {
  const { personSalaryReport } = props;
  const [personSalaryMessageKey, setPersonSalaryMessageKey] = React.useState<SnackbarKey>();

  const { enqueueMessage, closeMessage } = useFloatingMessages();

  React.useEffect(() => {
    if (personSalaryMessageKey) closeMessage(personSalaryMessageKey);
    if (personSalaryReport?.rows?.some((r) => r.warningsAndErrors?.length)) {
      const errorContent = <PersonSalaryWarningContent personSalaryReport={personSalaryReport} />;

      setPersonSalaryMessageKey(enqueueMessage(errorContent, StyleEnums.DisplayType.Danger));
    }
  }, [personSalaryReport]);

  return <></>;
};
export default SalaryReportWarnings;
